import React from 'react';

// Styles & Assets
import styles from './AssignPreconfigButton.module.css';

// Hooks
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Modal from '../../UI/Modal/Modal';
import AssignPreconfiguration from '../AssignPreconfiguration/AssignPreconfiguration';

// Interface
import { Preconfiguration } from '../../../interfaces/Preconfigurations';

interface Props {
    assign: boolean
    preconfig: Preconfiguration
    onAssigned?: () => void
}

const AssignPreconfigButton: React.FC<Props> = ({ assign, preconfig, onAssigned }) => {
    const { t } = useTranslation();

    const [showDialogAssign, setShowModalAssign] = useState(false);

    const handleClickAssign = (evt: React.FormEvent) => {
        evt.stopPropagation();
        setShowModalAssign(true);
    };

    const assignText = assign ? t('assign') : t('unassign');

    return (
        <>
            <button onClick={handleClickAssign} className={`${styles.assignButton} button`}>
                {assignText}
            </button>
            <Modal show={showDialogAssign} setShowModal={setShowModalAssign}>
                <div className='dialog'>
                    <h1 className='dialogTitle'>
                        {assignText} {t('patients').toLocaleLowerCase()}
                    </h1>
                    <h2 className='dialogSubTitle' style={{ marginBottom: '1.5rem' }}>
                        {preconfig.name}
                    </h2>
                    <AssignPreconfiguration
                        assign={assign}
                        preconfig={preconfig}
                        setShow={setShowModalAssign}
                        onAssigned={onAssigned}
                    />
                </div>
            </Modal>
        </>
    );
};

export default AssignPreconfigButton;